import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';

/**
 * Queries required to be invalidated
 * after finishing pinning flow
 */
const PINNING_QUERIES = [
  QUERY_KEY.GET_LIST_UNASSIGNED_STATION,
  QUERY_KEY.GET_PLACEMENT_LIST_IN_VENUE,
  QUERY_KEY.GET_VENUES_BY_GOOGLE_PLACE_IDS,
];

export const useInvalidatePinningQueries = () => {
  const queryClient = useQueryClient();

  const invalidatePinningQueries = useCallback(() => {
    PINNING_QUERIES.forEach((key) =>
      queryClient.invalidateQueries({ queryKey: [key] }),
    );
  }, [queryClient]);

  return { invalidatePinningQueries };
};
